import ConstantApi from '../../../ConstantApi';
import axiosCall from '../../axiosCall';
import {
    CREATE_FABRIC_INFORMATION_FAILURE,
    CREATE_FABRIC_INFORMATION_FORM,
    CREATE_FABRIC_INFORMATION_REQUEST,
    CREATE_FABRIC_INFORMATION_SUCCESS,
    DELETE_FABRIC_INFORMATION_FAILURE,
    DELETE_FABRIC_INFORMATION_REQUEST,
    DELETE_FABRIC_INFORMATION_SUCCESS,
    FETCH_FABRIC_BY_STYLE_DETAIL_ID_FAILURE,
    FETCH_FABRIC_BY_STYLE_DETAIL_ID_REQUEST,
    FETCH_FABRIC_BY_STYLE_DETAIL_ID_SUCCESS,
    FETCH_FABRIC_INFORMATION_FAILURE,
    FETCH_FABRIC_INFORMATION_REQUEST,
    FETCH_FABRIC_INFORMATION_SUCCESS,
    FETCH_FABRIC_MASTER_WITHOUT_STYLE_FAILURE,
    FETCH_FABRIC_MASTER_WITHOUT_STYLE_REQUEST,
    FETCH_FABRIC_MASTER_WITHOUT_STYLE_SUCCESS,
    FETCH_PROPERTY_FOR_FABRIC_INFO_FAILURE,
    FETCH_PROPERTY_FOR_FABRIC_INFO_REQUEST,
    FETCH_PROPERTY_FOR_FABRIC_INFO_SUCCESS,
    FETCH_SINGLE_FABRIC_INFORMATION_FAILURE,
    FETCH_SINGLE_FABRIC_INFORMATION_REQUEST,
    FETCH_SINGLE_FABRIC_INFORMATION_SUCCESS,
    RESET_FABRIC_INFORMATION_INFO,
    UPDATE_FABRIC_INFORMATION_FAILURE,
    UPDATE_FABRIC_INFORMATION_REQUEST,
    UPDATE_FABRIC_INFORMATION_SUCCESS,
    FETCH_FABRIC_INFO_INVOICE_REQUEST,
    FETCH_FABRIC_INFO_INVOICE_SUCCESS,
    FETCH_FABRIC_INFO_INVOICE_FAILURE,
    UPDATE_REGENERATE_FABRIC_INFORMATION_REQUEST,
    UPDATE_REGENERATE_FABRIC_INFORMATION_SUCCESS,
    UPDATE_REGENERATE_FABRIC_INFORMATION_FAILURE,
    SEND_FAB_VERIFY_OTP_USERFORM_REQUEST,
    SEND_FAB_VERIFY_OTP_USERFORM_SUCCESS,
    SEND_FAB_VERIFY_OTP_USERFORM_FAILURE,
    FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_FAILURE,
    FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_REQUEST,
    FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_SUCCESS
} from './fabricInformation.actionsType';

// FETCH FABRIC_INFORMATION DATA
export let fetchFabricInformationDetails = () => {
    let config = {
        method: 'get',
        url: ConstantApi.fabricGET,
        responseTypeRequest: FETCH_FABRIC_INFORMATION_REQUEST,
        responseTypeSuccess: FETCH_FABRIC_INFORMATION_SUCCESS,
        responseTypeFailure: FETCH_FABRIC_INFORMATION_FAILURE
    };
    return axiosCall(config);
};

// CREATE FABRIC_INFORMATION FORM
export let createFabricInformationForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_FABRIC_INFORMATION_FORM, payload: { key, value } });
    };
};

// CREATE FABRIC_INFORMATION
export let createFabricInformation = (formData, styleMaster, styleDetails) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldIsActive: true,
        fldIsVerified: true,
        fldIsAuthorized: true,
        fldPreparedOn: today.toISOString(),
        fldVerifiedOn: today.toISOString(),
        fldAuthorizedOn: today.toISOString(),
        fldPreparedBy: '',
        fldVerifiedBy: '',
        fldAuthorizedBy: '',
        ...formData,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldFKFabricGroup: parseInt(formData.fldFKFabricGroup),
        fldFKFabricType: 0,
        fldFKDepartment: parseInt(formData.fldFKDepartment),
        fldFKItem: parseInt(formData.fldFKItem),
        fldFKSupplier: parseInt(formData.fldFKSupplier),
        // fldFKLocation: parseInt(formData.fldFKLocation),
        fldPrice: formData.fldPrice
            ? formData.fldPrice.split('.').length >= 2
                ? parseFloat(formData.fldPrice)
                : parseInt(formData.fldPrice)
            : 0,
        fldTotalProcessPrice: formData.fldTotalProcessPrice
            ? formData.fldTotalProcessPrice.split('.').length >= 2
                ? parseFloat(formData.fldTotalProcessPrice)
                : parseInt(formData.fldTotalProcessPrice)
            : 0,
        fldDia: formData.fldDia ? (formData.fldDia.split('.').length >= 2 ? parseFloat(formData.fldDia) : parseInt(formData.fldDia)) : 0,
        fldGSM: formData.fldGSM ? (formData.fldGSM.split('.').length >= 2 ? parseFloat(formData.fldGSM) : parseInt(formData.fldGSM)) : 0,
        fldFKStyleDetail: parseInt(formData?.fldFKStyleDetail[0])
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.fabricPOST}?FldId=${formData?.fldFKStyleDetail.toString()}`,
        responseTypeRequest: CREATE_FABRIC_INFORMATION_REQUEST,
        responseTypeSuccess: CREATE_FABRIC_INFORMATION_SUCCESS,
        responseTypeFailure: CREATE_FABRIC_INFORMATION_FAILURE,
        resetFormData: RESET_FABRIC_INFORMATION_INFO,
        headers: {
            'Content-Type': 'application/json'
        },
        singlApiArray: [fetchFabricInformationByStyleDetailsId(styleMaster, styleDetails), updateSaleOrderAlterRegenerate(styleMaster)]
    };

    return axiosCall(config);
};

export let SendFabVerifyOTPMail = () => {
    let config = {
        method: 'post',
       // data: arrayData,
        url: `${ConstantApi.sendFabVerifyOTP}?FldStyleNo=KR780&FldSubStyleNo=KR780-001`,
        responseTypeRequest: SEND_FAB_VERIFY_OTP_USERFORM_REQUEST,
        responseTypeSuccess: SEND_FAB_VERIFY_OTP_USERFORM_SUCCESS,
        responseTypeFailure: SEND_FAB_VERIFY_OTP_USERFORM_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config);
};

// GET SINGLE FABRIC_INFORMATION
export let getSingleFabricInformation = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fabricGET_SINGLE_USER_ID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_FABRIC_INFORMATION_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_FABRIC_INFORMATION_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_FABRIC_INFORMATION_FAILURE
    };
    return axiosCall(config);
};

//UPDATE FABRIC_INFORMATION
export let updateFabricInformation = (formData) => {
    let today = new Date();
    let data = {
        ...formData,
        fldModifiedDt: today.toISOString()
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.fabricPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_FABRIC_INFORMATION_REQUEST,
        responseTypeSuccess: UPDATE_FABRIC_INFORMATION_SUCCESS,
        responseTypeFailure: UPDATE_FABRIC_INFORMATION_FAILURE,
        resetFormData: RESET_FABRIC_INFORMATION_INFO,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchFabricInformationDetails(),
        singlApiArray: [updateSaleOrderAlterRegenerate(formData?.fldFKStyle)]
    };
    return axiosCall(config);
};

// DELETE FABRIC_INFORMATION
export let deleteFabricInformation = (fabricGroup, fabricType, styleMaster, styleDetail, combineId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fabricDELETE}&Style=${styleMaster}&Styledetails=${styleDetail}&FldCombineId=${combineId}`,
        responseTypeRequest: DELETE_FABRIC_INFORMATION_REQUEST,
        responseTypeSuccess: DELETE_FABRIC_INFORMATION_SUCCESS,
        responseTypeFailure: DELETE_FABRIC_INFORMATION_FAILURE,
        singlApiArray: [fetchFabricInformationByStyleDetailsId(styleMaster, styleDetail), updateSaleOrderAlterRegenerate(styleMaster)]
    };
    return axiosCall(config);
};

export let fetchPropertyDataForFabricInfo = (propertyId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/${propertyId}`,
        responseTypeRequest: FETCH_PROPERTY_FOR_FABRIC_INFO_REQUEST,
        responseTypeSuccess: FETCH_PROPERTY_FOR_FABRIC_INFO_SUCCESS,
        responseTypeFailure: FETCH_PROPERTY_FOR_FABRIC_INFO_FAILURE,
        payload: propertyId
    };
    return axiosCall(config);
};

// FETCH FABRIC_INFORMATION BY STYLE DETAIL ID DATA
export let fetchFabricInformationByStyleDetailsId = (style, styleDetail) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fabricByStyleDetailIdGET}&Style=${style}&Styledetails=${styleDetail}`,
        responseTypeRequest: FETCH_FABRIC_BY_STYLE_DETAIL_ID_REQUEST,
        responseTypeSuccess: FETCH_FABRIC_BY_STYLE_DETAIL_ID_SUCCESS,
        responseTypeFailure: FETCH_FABRIC_BY_STYLE_DETAIL_ID_FAILURE
    };
    return axiosCall(config);
};

// FETCH FABRIC_INFORMATION BY STYLE DETAIL ID DATA
export let fetchAllFabricMaster = (style, styleDetail) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fabricMasterAllGET}?FldStyleId=${style}&FldStyleDetailId=${styleDetail}`,
        responseTypeRequest: FETCH_FABRIC_MASTER_WITHOUT_STYLE_REQUEST,
        responseTypeSuccess: FETCH_FABRIC_MASTER_WITHOUT_STYLE_SUCCESS,
        responseTypeFailure: FETCH_FABRIC_MASTER_WITHOUT_STYLE_FAILURE
    };
    return axiosCall(config);
};

export let getFabricInfoInvoiceData = (style, styleDetail) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fabricInfoInvoiceGET}?FldFKStyle=${style}`,
        //&FldStyleDetailId=${styleDetail}
        responseTypeRequest: FETCH_FABRIC_INFO_INVOICE_REQUEST,
        responseTypeSuccess: FETCH_FABRIC_INFO_INVOICE_SUCCESS,
        responseTypeFailure: FETCH_FABRIC_INFO_INVOICE_FAILURE
    };
    return axiosCall(config);
};
// /api/TblStylePrepYarn/UpdateSaleOrderAlterRegenerate?FldFKStyleMaster=60
export let updateSaleOrderAlterRegenerate = (FldFKStyleMaster) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.updateSaleOrderAlterRegenerateGET}?FldFKStyleMaster=${FldFKStyleMaster}`,
        //&FldStyleDetailId=${styleDetail}
        responseTypeRequest: UPDATE_REGENERATE_FABRIC_INFORMATION_REQUEST,
        responseTypeSuccess: UPDATE_REGENERATE_FABRIC_INFORMATION_SUCCESS,
        responseTypeFailure: UPDATE_REGENERATE_FABRIC_INFORMATION_FAILURE
    };
    return axiosCall(config);
};

export let fabricStyleDetailListCount = (FldFkStyleId, FldStyleDetailId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.fabricInformationAddGET}?FldFkStyleId=${FldFkStyleId}&FldStyleDetailId=${FldStyleDetailId}`,
        //&FldStyleDetailId=${styleDetail}
        responseTypeRequest: FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_REQUEST,
        responseTypeSuccess: FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_SUCCESS,
        responseTypeFailure: FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_FAILURE
    };
    return axiosCall(config);
};
